import { supabase } from '@/integrations/supabase/client';

export type ConferenciaProposta = {
  ok: boolean; codigo: string; motivo: string; acao: string;
  detalhes: Record<string, unknown>; log_id: string;
};

export async function conferirPropostaAtual(leadId: string, pedidoId: string | null = null): Promise<ConferenciaProposta> {
  const rpc = supabase.rpc.bind(supabase) as unknown as (fn: string, args: Record<string, unknown>) =>
    PromiseLike<{ data: ConferenciaProposta | null; error: { message?: string } | null }>;
  const { data, error } = await rpc('conferir_envio_proposta_atual', { p_lead_id: leadId, p_pedido_id: pedidoId });
  if (error || !data) {
    const motivo = error?.message?.trim();
    throw new Error(`Não foi possível conferir e registrar a versão da proposta${motivo ? ` (${motivo})` : ''}. Tente novamente sem reenviar ao cliente.`);
  }
  return data;
}
